import React, { type PropsWithChildren, useMemo } from 'react';
import MockPromptService from '../services/MockPromptService';
import { useAuth } from '../../../contexts/auth/AuthContext';
import PromptProvider from './PromptContext';

const MockPromptServiceProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { getAccessToken } = useAuth();

    const service = useMemo(() => new MockPromptService(getAccessToken), [getAccessToken]);

    return (
        <PromptProvider service={service}>
            {children}
        </PromptProvider>
    );
};

export default MockPromptServiceProvider;